export default {
  en: {    
  	layout: {
  		search: 'Search',
      offers: 'Offers',
      myshipments: 'My shipments',
      fleet: 'Fleet'
  	}  	  	
  },
  nl: {    
  	layout: {
      search: 'Zoeken',
      offers: 'Biedingen',
      myshipments: 'Mijn zendingen',
      fleet: 'Vloot'
  	}  	  	  	
  },
  fr: {    
  	layout: {
      search: 'Recherche',
      offers: 'Offres',
      myshipments: 'Mes envois',
      fleet: 'Flotte'
  	}  	  	  	
  }
}
